import React from "react";

const RulerDimensionLine = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10 12.5V9.98837M13.3333 12.5V9.98837M16.6667 5.00004H3.33333M16.6667 6.66671V3.33337M3.33333 6.66671V3.33337M6.66667 12.5V9.98837M3.33333 10H16.6667C17.1269 10 17.5 10.3731 17.5 10.8334V15C17.5 15.4603 17.1269 15.8334 16.6667 15.8334H3.33333C2.8731 15.8334 2.5 15.4603 2.5 15V10.8334C2.5 10.3731 2.8731 10 3.33333 10Z"
        stroke="#0068FF"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default RulerDimensionLine;
